import React, { useState, useEffect } from "react";
import yerlembg from "../images/yerlemicon.svg";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import Moment from "react-moment";
import "moment/locale/tr";
import "./style.css";
import { API_IP } from "./AppConfig/AppConfig";
import { InputText } from "primereact/inputtext";

export default function MessageLog({ setSidebarVisible }) {
  const items = Array.from({ length: 18 }, (v, i) => i);

  const bodyTemplate = () => {
    return <Skeleton></Skeleton>;
  };
  const handleShowDialog = (content, phone) => {
    setDialogContent(content);
    setDialogPhone(phone);
    setShowDialog(true);
  };
  const hideDialog = () => {
    setShowDialog(false);
    setDialogContent("");
    setDialogPhone("");
  };
  const onTextChange = async (event) => {
    setSearchText(event.target.value);
    fetchData();
  };

  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalElements, setTotalElements] = useState(null);
  const [dialogContent, setDialogContent] = useState("");
  const [dialogPhone, setDialogPhone] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    fetchData();
  };

  const fetchData = async () => {
    try {
      setDataLoading(true);
      const smsData = await fetch(
        `http://${API_IP}:7077/messages/findByLikeIgnoreCase?page=${
          first / rows
        }&size=${rows}${
          searchText === null || searchText === ""
            ? null
            : `&param=${searchText}`
        }`, // API'den veri çekme işlemi
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Add any additional headers if needed
          },
        }
      );
      const smsDataJson = await smsData.json();
      setDataLoading(false);
      setData(smsDataJson.content);
      setTotalElements(smsDataJson.totalElements);
    } catch (error) {
      console.error("catch oluştu:", error);
    }
  };
  const generateDialogContent = (text) => {
    // API'den gelen veriyi uygun formata getirme işlemi
    const formattedData = text.replace(/\\n/g, "\n");

    // Her bir satırı alıp paragraf haline getirme işlemi
    const paragraphs = formattedData.split("\n");

    // Paragrafları içeren JSX öğelerini oluşturma işlemi
    const content = paragraphs.map((paragraph, index) => (
      <p key={index}>{paragraph}</p>
    ));

    return content;
  };
  useEffect(() => {
    fetchData();
  }, [first, rows]);
  const maskPhoneNumber = (phoneNumber) => {
    // Telefon numarasını maskeleme işlemi
    const maskedNumber = phoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2 $3"
    );
    return maskedNumber;
  };
  return (
    <div className="w-full h-full py-4 px-36 ">
      <Dialog
        header={"Detayı : " + dialogPhone}
        visible={showDialog}
        onHide={hideDialog}
        style={{ width: "50vw" }}
      >
        {generateDialogContent(dialogContent)}
      </Dialog>

      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <div className="relative flex h-full items-center justify-start gap-6 flex-col">
        <img
          src={yerlembg}
          alt="Logo"
          className="absolute h-full object-cover z-0 "
        />
        <InputText
          className="w-full z-2"
          placeholder="Aramak için metin giriniz"
          onKeyUp={(e) => onTextChange(e)}
        />
        {dataLoading ? (
          <DataTable
            value={items}
            style={{ width: "100%" }}
            className="p-datatable-striped"
          >
            <Column header="Numara" body={bodyTemplate}></Column>
            <Column header="Port" body={bodyTemplate}></Column>
            <Column header="Uygulama" body={bodyTemplate}></Column>
            <Column header="Mesaj Başlığı" body={bodyTemplate}></Column>
            <Column header="Mesaj İçeriği" body={bodyTemplate}></Column>
            <Column header="Tipi" body={bodyTemplate}></Column>
            <Column header="Tarih" body={bodyTemplate}></Column>
          </DataTable>
        ) : (
          <div className="w-full z-1 ">
            <DataTable size="small" value={data} style={{ width: "100%" }}>
              <Column
                field="messageSentPhone"
                className="text-black text-xl font-semibold w-1/12 "
                header="Numara"
                body={(
                  rowData // Her bir satır için özel işlem yapma işlemi
                ) => (
                  <Tag
                    icon="pi pi-phone"
                    className={`py-2 gap-2 text-black bg-blue-200`}
                    value={maskPhoneNumber(rowData.messageSentPhone)}
                  ></Tag>
                )}
              />
              <Column
                field="messageSentPort"
                className="w-1/12 text-black"
                header="Port"
                body={(
                  rowData // Her bir satır için özel işlem yapma işlemi
                ) => (
                  <p className="text-black font-semibold">
                    {rowData.messageSentPort}
                  </p>
                )}
              />
              <Column
                field="messageSentApp"
                className="w-2/12  text-black"
                header="Uygulama"
              />
              <Column
                field="messageHeader"
                className="w-1/12 text-black"
                header="Mesaj Başlığı"
                body={(
                  rowData // Her bir satır için özel işlem yapma işlemi
                ) => (
                  <p className="text-black font-semibold">
                    {rowData.messageHeader}
                  </p>
                )}
              />

              <Column
                field="messageSentType"
                className=" w-1/12 text-black"
                header="Tipi"
                body={(rowData) => (
                  <Tag
                    icon={
                      rowData.messageSentType === "single"
                        ? "pi pi-user"
                        : "pi pi-users"
                    }
                    className={`py-2 px-4 gap-2 text-black ${
                      rowData.messageSentType === "single"
                        ? "bg-green-200"
                        : "bg-orange-200"
                    }`}
                    value={rowData.messageSentType}
                  ></Tag>
                )}
              />
              <Column
                field="createdAt"
                className="w-1/12 text-black "
                header="Tarih"
                body={(rowData) => (
                  <Moment
                    parse="YYYY-MM-DDTHH:mm:ss"
                    format="DD-MM-YYYY HH:mm"
                    locale="tr"
                    className=" text-black font-semibold"
                  >
                    {rowData.createdAt}
                  </Moment>
                )}
              />
              <Column
                field={["message", "messageSentPhone"]}
                header="Mesaj İçeriği"
                className="w-2/12"
                body={(rowData) =>
                  rowData.message !== null || rowData.message !== "" ? (
                    <Button
                      className="h-full"
                      label="Mesajı İncele"
                      icon="pi pi-eye"
                      onClick={() =>
                        handleShowDialog(
                          rowData.message,
                          rowData.messageSentPhone
                        )
                      }
                      severity="secondary"
                      text
                    />
                  ) : (
                    <Button
                      className="h-full"
                      label="Mesaj içeriği yok"
                      icon="pi pi-eye-slash"
                      disabled
                      severity="secondary"
                      text
                    />
                  )
                }
              />
            </DataTable>
            <Paginator
              className="z-1 my-2"
              first={first}
              rows={rows}
              totalRecords={totalElements}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}
